export { default as Flex } from './Flex';
export type { FlexProps } from './types';
